import { createStore } from "hooksy";

type State = {
  fetchList: boolean;
};

const defaultValue: State = { fetchList: false };

export const [useLandingZoneStore] = createStore(defaultValue);
